module.exports = __webpack_public_path__ + "static/media/flag-usa.b08cce47.png";